export default [
    {
        path: '/notice',
        component: () => import('@/views/notice/notice'),
    },
]